var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2147_129)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5172 6.14336C15.6548 6.14336 17.669 7.09099 19.1452 8.57236V8.57674C19.1452 7.86536 19.6238 7.32724 20.2853 7.32724H20.4533C21.4972 7.32724 21.7063 8.31161 21.7063 8.62224L21.7107 19.6779C21.638 20.4024 22.4588 20.7769 22.9147 20.3114C24.6865 18.4887 26.8102 10.9322 21.8113 6.55724C17.1493 2.47361 10.8922 3.14824 7.56541 5.44074C4.02954 7.88374 1.76941 13.2799 3.96479 18.3514C6.36229 23.8805 13.2162 25.5299 17.2954 23.8849C19.3604 23.051 20.3124 25.8387 18.166 26.7514C14.9312 28.1312 5.91604 27.9904 1.70554 20.699C-1.13909 15.7736 -0.988588 7.10936 6.55916 2.62061C12.328 -0.815515 19.9397 0.136486 24.5282 4.92711C29.3232 9.93999 29.0458 19.3191 24.3645 22.9652C22.2444 24.6234 19.0962 23.0107 19.1189 20.5949L19.0953 19.8074C17.6192 21.2695 15.6548 22.127 13.5172 22.127C9.28829 22.127 5.56516 18.403 5.56516 14.1785C5.56516 9.90849 9.28829 6.14511 13.5172 6.14511V6.14336ZM18.8363 13.8731C18.6762 10.7782 16.3793 8.91448 13.6038 8.91448H13.4988C10.2998 8.91448 8.52266 11.4345 8.52266 14.2914C8.52266 17.4947 10.669 19.5177 13.4857 19.5177C16.6295 19.5177 18.6937 17.2174 18.8442 14.4961L18.8363 13.8731Z",
    fill: "#4575E3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2147_129"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.b1144ba39fd0d433b9c304f298d4e890.svg";
export { ForwardRef as ReactComponent };